import { SelectOption } from '@/components/selectValidate';
import React from 'react';
import { ObjectType } from '@/shared/entities/types';
import { getToken } from '@/utils/authentication';
import { Select, Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

import { LogoProvider } from '../..';

interface SelectProviderProps {
  name: string;
  onChange: Function;
  value?: string;
  onBlur?: Function;
  errors?: ObjectType;
  small?: boolean;
  companyId?: string;
  disabled?: boolean;
}

const SelectProvider: React.FC<SelectProviderProps> = ({
  name,
  onChange,
  value,
  onBlur,
  errors,
  small,
  companyId,
  disabled,
}) => {
  return (
    <Select
      key={companyId}
      clearable
      autoRequest
      label='Fornecedor'
      onBlur={(value) => !disabled && onBlur?.(name, value)}
      onChange={(value, selected: SelectOption) => !disabled && onChange?.(name, value, selected)}
      requestPageParam='page'
      requestResponseRootPath='data'
      requestResponseText='name'
      requestResponseValue='id'
      requestRouter='/providers'
      requestSearchParam='q'
      requestUri={process.env.REACT_APP_API_NEGOTIATIONS_URL}
      requestHeaders={{ authorization: `Bearer ${getToken()}` }}
      requestParams={
        companyId
          ? {
              'products.negotiations.costCenter.companyId': companyId,
            }
          : {}
      }
      searchable
      textHelper={!disabled ? errors?.[name] ?? '' : undefined}
      value={value || ''}
      small={small}
      customOption={(provider: ObjectType) => (
        <Grid gap={8} alignItems='center'>
          <div style={{ minWidth: 20 }}>
            <LogoProvider providerCnpj={provider?.cnpj} size='minor' />
          </div>

          <Text size='medium' value={provider.text} />
        </Grid>
      )}
    />
  );
};

export default SelectProvider;
